import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { ITerminalId, ITerminalCardGroupResposne } from '../models/terminal.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Gets a terminal's card group data
 * 
 * @param {object} terminal the terminal object
 * 
 * @returns {object} the api response
 */
export const getTerminalCardGroup = async ( terminal: ITerminalId ): Promise<ITerminalCardGroupResposne> => {
  try {
    apiRetry(awsApiInstance);

    const { userId } = useAuth()!;

    const { data } = await awsApiInstance.get(`/terminal/${terminal.terminalID}/card-group`, {
      params: {
        'wpID': userId,
        'terminalID': terminal.terminalID,
        'cardGroupID': terminal.cardGroups
      }
    });

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error getting terminal card group data');
    throw(error);
  }
}
